export default {
  SET_STEPS(state, steps) {
    state.steps = steps
  },
  SET_PROGRESS(state, progress) {
    state.progress = progress
  },
  SET_EXPANDED(state, expanded) {
    state.isExpanded = expanded
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading
  },
  ADD_PROGRESS(state, progressItem) {
    // Evitar duplicatas
    const exists = state.progress.find(p => p.stepKey === progressItem.stepKey)
    if (!exists) {
      state.progress.push(progressItem)
    }
  },
  SET_HAS_COMPLETED_ALL(state, value) {
    state.hasCompletedAll = value
  }
}
